module.exports = __webpack_public_path__ + "img/google-maps.35cc394a.png";